import { TextFieldClassKey } from '@material-ui/core/TextField';

const MuiTextField = (): Partial<Record<TextFieldClassKey, unknown>> => ({
    root: {
        '& [class*="MuiSelect-root"]': {
            '& svg': {
                visibility: 'hidden',
            },
        },
    },
});

export default MuiTextField;
